export default "__VITE_PUBLIC_ASSET__d0fcab9d__"